import { useContext } from "react"

import useIsDesktop from "@hooks/useIsDesktop"

import DrawerHeader from "@atoms/BottomDrawer/DrawerHeader/DrawerHeader"
import type {
    DrawerHeaderActionsProps,
    DrawerHeaderBackButtonProps,
    DrawerHeaderCloseButtonProps,
    DrawerHeaderRootProps,
    DrawerHeaderTitleProps,
} from "@atoms/BottomDrawer/DrawerHeader/DrawerHeader.types"

import { PopoverContext } from "@molecules/Popover/Popover"
import PopoverHeader from "@molecules/Popover/PopoverHeader/PopoverHeader"

/**
 * Render DrawerHeader when the surface is a mobile drawer and PopoverHeader everywhere else.
 *
 * With no children it is the drawer's drag handle alone, and nothing outside a drawer.
 */
function PopoverSurfaceHeaderRoot(props: DrawerHeaderRootProps) {
    const { showDragHandle, ...rest } = props
    const { mobilePresentation } = useContext(PopoverContext)
    const isDesktop = useIsDesktop()

    const isMobileDrawer = !isDesktop && mobilePresentation === "drawer"

    if (isMobileDrawer) {
        return <DrawerHeader.Root showDragHandle={showDragHandle} {...rest} />
    } else if (rest.children) {
        return <PopoverHeader.Root {...rest} />
    } else {
        return null
    }
}

function PopoverSurfaceHeaderTitle(props: DrawerHeaderTitleProps) {
    return <PopoverHeader.Title {...props} />
}

function PopoverSurfaceHeaderActions(props: DrawerHeaderActionsProps) {
    return <PopoverHeader.Actions {...props} />
}

function PopoverSurfaceHeaderBackButton(props: DrawerHeaderBackButtonProps) {
    return <PopoverHeader.BackButton {...props} />
}

function PopoverSurfaceHeaderCloseButton(props: DrawerHeaderCloseButtonProps) {
    return <PopoverHeader.CloseButton {...props} />
}

export default {
    Root: PopoverSurfaceHeaderRoot,
    Title: PopoverSurfaceHeaderTitle,
    Actions: PopoverSurfaceHeaderActions,
    BackButton: PopoverSurfaceHeaderBackButton,
    CloseButton: PopoverSurfaceHeaderCloseButton,
}
